import Autoplay from '../../components/video/autoplay';

const videos = document.querySelectorAll('video[autoplay]');
const instances = [];

videos.forEach((video) => {
  if (instances.includes(video)) return;
  instances.push(new Autoplay(video));
});
